import Joi from '@hapi/joi'

export const EmployeeBiometricDetailsObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name characters`
    }),
    divisionID: Joi.number().label("DIvision Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name characters`
    })
}